import React from "react";
import { CloseHealth, closeHealthLabels } from "@common/types/closeHealth";
import { BaseFilterProps } from "../../lib";
import { EnumMultiselectFilter } from "../EnumMultiselectFilter/EnumMultiselectFilter";

const healthStatuses = Object.values(CloseHealth);

export const HealthFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => (
    <EnumMultiselectFilter
        values={healthStatuses}
        labels={closeHealthLabels}
        value={filters.healthStatuses}
        name="healthStatuses"
        onChange={(selected) => onChange({ healthStatuses: selected })}
    />
);
